<template>
    <!-- <q-slide-transition> -->
    <div class="answer-box">
        <p><b>정답</b> <span v-html="answer.detail"></span></p>
        <p><b>해설</b> <span v-html="answer.explain"></span></p>
    </div>
</template>

<script setup>
import { onMounted, onUnmounted, defineEmits, defineProps, ref, watch, toRaw } from 'vue';
import { getAnswer } from '@/helpers/qbankParser/qbankDataParse';

const answer = ref('');
const visible = ref(false);

const emit = defineEmits(['onIntersection']);

const props = defineProps({
    pContent: {
        default: {},
    },
    isStudy: {
        Type: Boolean,
        default: false,
    },
});

watch(
    () => props.pContent,
    (newValue) => {
        // console.log('watch !!!!! ');
        visible.value = false;
        init(newValue);
    },
);
const init = (pContent) => {
    const vContent = toRaw(pContent);
    // console.log('--solution_eval--onMounted-- vContent.data --', vContent);

    if (vContent) answer.value = getAnswer(vContent.data);
    // console.log('--solution_eval--onMounted-- answer.value --', answer.value);
};
onMounted(() => {
    // console.log('--solutionEval--isStudy--', props.isStudy);
    init(props.pContent);
});

onUnmounted(() => {
    // console.log('-solution_eval--onUnmounted !!!!! ');
    visible.value = false;
});
</script>

<style lang="scss" scoped>
.answer-box {
    padding: 20px;
    margin: 20px 0;
    background: #eeeeee;
    border-radius: 10px;
}

::v-deep .q-dialog__inner {
    justify-content: end;
}

.q-dialog__inner :deep {
    justify-content: end;
}
</style>
